<template>
  <div class="soda-features-view mt-6">
    <v-container>
      <v-row>
        <v-col cols="8">
          <v-row class="primary--text"><b>SODA Features</b></v-row>
          <v-row>
            <ul>
              <li>Online-Verzeichnis gem. Art. 30 DSGVO (Verzeichnis aller Verarbeitungstätigkeiten, ehemals Verfahren)</li>
              <li>Online Verwaltung der technischen und organisatorischen Maßnahmen (TOM)</li>
              <li>Intelligenter Audit-Modus</li>
              <li>Einzigartige Verknüpfung zwischen Verarbeitungstätigkeit und TOMs</li>
              <li>Export von Verzeichnis und TOM als PDF für Auftraggeber und Behörde</li>
              <li>Erstellen eigener To-Do Listen als PDF für Audits und intere Aufgabenverteilungen</li>
              <li>Dokumentenorganisation in der App</li>
              <li>Detaillierte Verzeichnisvorlagen für Vereine, Ärtze und Ärztinnen und Steuerberater:innen</li>
              <li>Generische Vorlage für alle Unternehmensformen</li>
              <li>Vorgeschlagene Maßnahmen in den Vorlagen als Beratung</li>
              <li>Verwaltung mehrerer Unternehmen / Verantwortlicher möglich</li>
              <li>Intuitive Bedienung</li>
            </ul>
          </v-row>
        </v-col>
        <v-col cols="4" align="center">
          <video src="bla.mp4" />
        </v-col>
      </v-row>
    </v-container>
    <div class="wrapper">
      <v-btn class="primary--text secondary mr-12" outlined @click="onSignup()"
              >kostenlos Testen</v-btn
            >
    </div>
  </div>
</template>

<script>
export default {
  name: "SodaFeaturesView",

  methods: {},
  data: function() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: center;
}
</style>
